module.exports = __webpack_public_path__ + "img/zanwushuju-2@2x.e326f4bd.png";